module.exports = __webpack_public_path__ + "img/ANGELLEAGUE@3x.2f5ee82d.png";